<template>
  <div
    :class="{
      'absolute left-0 top-[3.8125rem] z-10 w-full shadow-[0_8px_16px_0_rgba(0,0,0,.2)] transition-all duration-0 md:top-[5.0625rem]': true,
      'border-www-color-primary-lighter md:border-t-2': true,
      'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
    }"
  >
    <!-- Divider in mobile view -->
    <div
      :class="{
        'divider ml-10 mr-25px border-b border-www-color-neutral-medium md:hidden': true,
      }"
    ></div>

    <div
      :class="{
        'max-h-screen overflow-y-auto overflow-x-hidden pb-20 md:max-h-[calc(100vh-72px)] md:overflow-y-auto md:pb-0': true,
      }"
    >
      <div
        :class="{
          'gap-x-gutter grid grid-cols-12 gap-y-0 sm:grid-cols-8 md:grid-cols-12': true,
        }"
      >
        <div
          :class="{
            'left-col col-span-12 lg:col-span-4': true,
          }"
        >
          <div
            :class="{
              'flex flex-col pt-5 md:pt-0': true,
            }"
          >
            <NavProductCard
              v-if="highlightCorner"
              v-bind="highlightCorner"
            />
            <NavFeaturedCard
              v-if="featureData"
              :heading="featuredCard?.heading"
              :card="featureData"
              menu-type="product"
              :class="{
                'hidden md:block': true,
              }"
            />
          </div>
        </div>

        <div
          :class="{
            'right-col col-span-12 h-full px-8 py-50px md:px-70px lg:col-span-8': true,
            'grid grid-cols-12 gap-10': true,
            'bg-www-color-neutral-medium-dark md:bg-www-color-neutral-off-white': true,
          }"
        >
          <div
            :class="{
              'col-span-12 md:col-span-3': true,
              'max-w-[85%] pl-10 pr-40 md:max-w-none md:px-0': true,
            }"
          >
            <ProductMegaMenuColumn
              v-if="modernCad"
              v-bind="modernCad"
            />
          </div>
          <div
            :class="{
              'col-span-12 md:col-span-3': true,
              'max-w-[85%] pl-10 pr-40 md:max-w-none md:px-0': true,
            }"
          >
            <ProductMegaMenuColumn
              v-if="PDMReleaseManagement"
              v-bind="PDMReleaseManagement"
            />
            <ProductMegaMenuColumn
              v-if="ProductLifecycleManagement"
              v-bind="ProductLifecycleManagement"
              :class="{
                'mt-30px': true,
              }"
            />
          </div>
          <div
            :class="{
              'col-span-12 md:col-span-3': true,
              'max-w-[85%] pl-10 pr-40 md:max-w-none md:px-0': true,
            }"
          >
            <ProductMegaMenuColumn
              v-if="realTimeCommunication"
              v-bind="realTimeCommunication"
            />
            <ProductMegaMenuColumn
              v-if="admin"
              v-bind="admin"
              :class="{
                'mt-30px': true,
              }"
            />
          </div>
          <div
            :class="{
              'col-span-12 md:col-span-3': true,
              'max-w-[85%] pl-10 pr-40 md:max-w-none md:px-0': true,
            }"
          >
            <ProductMegaMenuColumn
              v-if="moreThanCAD"
              v-bind="moreThanCAD"
            />
          </div>
        </div>
      </div>
      <div
        :class="{
          'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
        }"
      >
        <NavFeaturedCard
          v-if="featureData"
          :heading="featuredCard?.heading"
          :card="featureData"
          menu-type="product"
          :view-all-button="viewAllButton"
          :class="{
            'block md:hidden': true,
          }"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { ProductDropdown, CardBlogResult } from '~/sanity/types';
import NavProductCard from './NavProductCard.vue';
import NavFeaturedCard from './NavFeaturedCard.vue';
import ProductMegaMenuColumn from './ProductMegaMenuColumn.vue';
type PropType = ProductDropdown & {
  featureData?: CardBlogResult;
};
defineProps<PropType>();
</script>
<style lang="scss" scoped></style>
